import { RootPath } from '@router';
import { matchPath } from 'react-router-dom';

interface MatchOptions {
    pathname: string;
    search: string;
    targetTo: string;
    pattern?: string;
    end?: boolean;
}

export const isUrlActive = ({
    pathname,
    search,
    targetTo,
    pattern,
    end,
}: MatchOptions): boolean => {
    const [targetPath, targetSearch] = targetTo.split('?');

    const isPathActive = !!matchPath(
        { path: pattern ?? targetPath, end: end ?? targetPath === RootPath },
        pathname,
    );

    if (!targetSearch || !isPathActive) return isPathActive;

    const targetParams = new URLSearchParams(targetSearch);
    const currentParams = new URLSearchParams(search);

    return Array.from(targetParams.entries()).every(
        ([key, val]) => currentParams.get(key) === val,
    );
};
